"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_jss_1 = __importDefault(require("react-jss"));

var BurnerProvider_1 = require("../BurnerProvider");

var style = function style(theme) {
  return {
    overlay: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      background: 'rgba(0, 0, 0, 0.5)',
      padding: 15,
      display: 'flex',
      flexDirection: 'column',
      zIndex: 100,
      alignItems: 'center',
      color: 'white',
      justifyContent: 'center',
      fontSize: 32
    }
  };
};

var Loading = function Loading(_a) {
  var classes = _a.classes,
      loading = _a.loading;

  if (!loading) {
    return null;
  }

  return react_1.default.createElement("div", {
    className: classes.overlay
  }, loading);
};

exports.default = react_jss_1.default(style)(BurnerProvider_1.withBurner(Loading));